module.exports = __webpack_public_path__ + "img/ghs.06fd8637.jpg";